import { useEffect, useState } from 'react';

// True once the element has scrolled above the viewport. Read on scroll rather than with an
// IntersectionObserver, which misses a jump (anchor, fast fling) from below to above it.
const useScrolledPast = (ref) => {
  const [past, setPast] = useState(false);

  useEffect(() => {
    // Captured once: React clears ref.current on unmount before this cleanup runs, and a scroll
    // event in between (route change scroll reset) would otherwise read null.
    const element = ref.current;
    if (!element) return undefined;

    const update = () => setPast(element.getBoundingClientRect().bottom < 0);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [ref]);

  return past;
};

export default useScrolledPast;
